var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRolesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    style: {
      enableBackground: "new 0 0 17 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4,1.7h-3.7V0.5c0-0.3-0.2-0.5-0.5-0.5H6.8C6.5,0,6.3,0.2,6.3,0.5v1.2H2.6C1.2,1.7,0,2.8,0,4.2v10.2 C0,15.8,1.2,17,2.6,17h11.8c1.4,0,2.6-1.2,2.6-2.6V4.3C17,2.8,15.8,1.7,14.4,1.7z M7.3,1h2.4v2.3H7.3V1z M5.9,9.4 c0-1.4,1.2-2.6,2.6-2.6s2.6,1.2,2.6,2.6S9.9,12,8.5,12S5.9,10.9,5.9,9.4z M12.7,16H4.3c0.8-1.6,2.4-2.6,4.2-2.6S11.9,14.4,12.7,16z  M16,14.4c0,0.9-0.7,1.5-1.5,1.5h-0.6c-0.6-1.6-2-2.8-3.6-3.4c1.1-0.6,1.9-1.8,1.9-3.2c0-2-1.6-3.7-3.7-3.7S4.8,7.4,4.8,9.4 c0,1.4,0.8,2.6,1.9,3.2c-1.6,0.5-2.9,1.8-3.6,3.4H2.6C1.7,16,1,15.3,1,14.4V4.2c0-0.9,0.7-1.5,1.5-1.5h3.7v1.2 c0,0.3,0.2,0.5,0.5,0.5h3.4c0.3,0,0.5-0.2,0.5-0.5V2.7h3.7c0.9,0,1.6,0.7,1.6,1.6V14.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRolesIcon);
export default __webpack_public_path__ + "static/media/roles-icon.5215f3ed6a6ee52dcca8834c3cd64c5a.svg";
export { ForwardRef as ReactComponent };